import { AppSelectPreviewType } from '@/ui/select-preview';
import {
  ContentGridViewIcon,
  ContentListViewIcon,
  ContentViewMode,
  contentViewOptions,
} from '@/utils/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ContentViewToggleContainer = styled.div`
  && .p-selectbutton {
    border-radius: var(--grand-border-radius);

    .p-button {
      width: auto;
      padding: var(--xsmall-padding) 9px;
      border-radius: var(--grand-border-radius);
      background-color: transparent;

      svg {
        width: 24px;
        height: 24px;
      }

      &.p-highlight {
        background-color: var(--white-main);
        border: none;
        box-shadow: none;
      }
    }
  }
`;

type ContentViewTogglePropsType = {
  value: ContentViewMode;
  onChange: (viewMode: ContentViewMode) => void;
};

export const ContentViewToggle = ({
  value,
  onChange,
}: ContentViewTogglePropsType) => {
  const { t } = useTranslation();

  const options = contentViewOptions(t).map((option) => ({
    ...option,
    icon:
      option.value === ContentViewMode.MANAGE ? (
        <ContentListViewIcon />
      ) : (
        <ContentGridViewIcon />
      ),
  }));

  const handleViewModeChange = (viewMode: ContentViewMode) => {
    if (!viewMode) return;

    onChange(viewMode);
  };

  return (
    <ContentViewToggleContainer>
      <AppSelectPreviewType
        options={options}
        optionLabel="label"
        selectedPreviewType={value}
        setSelectedPreviewType={handleViewModeChange}
      />
    </ContentViewToggleContainer>
  );
};
